<div
  dropdown
  (onHidden)="onHidden()"
  (isOpenChange)="toggleMenu.emit($event)"
  keyboard-nav="true"
  class="dropdown"
>
  <button
    dropdownToggle
    class="btn btn-lg btn-lg--fa-square btn-link status-selection"
    data-bs-toggle="dropdown"
    [id]="itemMenuButtonId"
    type="button"
    title="View actions menu"
    i18n-title="@@viewItemMenu-title-viewActionsMenu"
  >
    <i class="far fa-fw fa-ellipsis-v" aria-hidden="true"></i>
    <span class="sr-only" i18n="@@viewItemMenu-label-viewActionsMenuForItem"
      >View actions menu for item</span
    >
  </button>

  <ul *dropdownMenu class="qa-actions-dropdown dropdown-menu dropdown-menu-end">
    <li>
      <button
        class="dropdown-item qa-add-to-my-bookmarks"
        [class.disabled]="
          isSubscribedToResource?.data || isSubscribedToResource?.isLoading
        "
        type="button"
        [disabled]="
          isSubscribedToResource?.data || isSubscribedToResource?.isLoading
        "
        [ngSwitch]="isSubscribedToResource?.data"
        (click)="addToMyBookmarks.emit({ resource: resourceId })"
      >
        <ng-container
          *ngSwitchCase="true"
          i18n="@@viewItemMenu-btn-inMyBookmarks"
          >In My Bookmarks</ng-container
        >
        <ng-container
          *ngSwitchDefault
          i18n="@@viewItemMenu-btn-addToMyBookmarks"
          >Add to My Bookmarks</ng-container
        >
      </button>
    </li>

    <li class="dropdown-divider" role="presentation"></li>

    <li>
      <button
        class="dropdown-item qa-edit-note"
        [class.disabled]="!canUpdateStudyNote"
        type="button"
        [disabled]="!canUpdateStudyNote"
        (click)="canUpdateStudyNote && onStudyNoteEdit($event)"
        i18n="@@viewItemMenu-btn-editPersonalNote"
      >
        Personal note
      </button>
    </li>

    <li class="dropdown-divider" role="presentation"></li>

    <li>
      <a
        [href]="risExportUrl"
        (click)="onExportItemCitation()"
        (keyup.enter)="onExportItemCitation()"
        class="dropdown-item qa-export-citation"
      >
        <ng-container i18n="@@viewItemMenu-link-downloadRis"
          >Download RIS</ng-container
        >
      </a>
    </li>

    <li class="dropdown-divider" role="presentation"></li>

    <li *ngIf="hasListEditPermission && containerMode === ContainerModes.View">
      <a [href]="resourceEditUrl" class="dropdown-item qa-edit-resource">
        <ng-container i18n="@@viewItemMenu-link-editMetadata"
          >Edit metadata</ng-container
        >
      </a>
    </li>

    <li *ngIf="isReportBrokenLinkEnabled">
      <button
        (click)="onShowReportBrokenLinkModal()"
        class="dropdown-item qa-report-broken-link"
        type="button"
        aria-haspopup="true"
        i18n="@@viewItemMenu-btn-reportBrokenLink"
      >
        Report broken link
      </button>
    </li>

    <li>
      <button
        (click)="onShowShareSheet()"
        class="dropdown-item qa-share-item"
        type="button"
        aria-haspopup="true"
      >
        <ng-container i18n="@@viewItemMenu-btn-shareItem"
          >Share item</ng-container
        >
      </button>
    </li>
  </ul>
</div>
